import React, { useEffect, useReducer, useState } from "react";
import { use } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { connectToStore } from "../data/store";
import UserHelper from "../core/UserHelper";
import { AddNewVendorPage, ProductIntakesPage, ProductInvoicePage } from "../core/PageConstants";
import { Box, Container, Stack } from "@mui/system";
import {
  Button,
  Card,
  FormControl,
  Grid,
  IconButton,
  Input,
  TextField,
  Typography,
  Tooltip,
  CardContent,
  Alert,
} from "@mui/material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import SideBarMenuItems from "./SideBarMenuItems";
import { MaxFileSizeLimit, SideBarMenuNames } from "../core/Constants";
import CartComponent from "./common/CartComponent";
import { serviceItemReducer } from "./reducers/serviceItem/serviceItemReducer";
import Utils from "../core/Utils";
import {
  convertServiceItemObject,
  getServiceItemFromProduct,
  getServiceItemProductsFromProduct,
  getSpares,
} from "../helpers/productHelper";
import { serviceItemActionTypes } from "./reducers/serviceItem/serviceItemActionTypes";
import MessagePopup from "./common/MessagePopUp";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import { postAsync } from "../core/serviceClient";
import Loader from "./common/Loader";
import AddNewProduct from "./common/AddNewProduct";
import CustomAddProductSelection from "./common/CustomAddProductSelection";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import VendorSelectionDialog from "./dialogs/VendorSelectionDialog";
import DecimalEntryField from "./common/controls/DecimalEntryField";

const AlertMessageTxt = {
  productAlreadyAdded: "Product already added",
  fileSixeExceeded:
    "Unable to upload. File size exceeds the maximum limit, please ensure that it's less than 10 MB.",
  addProducts: "Please add product items before submiting",
  productIntakeSaved: "Product Intake saved successfully",
  productIntakeUpdated: "Product Intake updated successfully",
  confirmUpdateMethod:
    "Confirm update? This will update inventory and vendor ledgers, and the changes cannot be reversed.",
  FillPriceDetails: "Fill the price details of every product intake"
};

const ProductInvoice = () => {
  document.title = "Add Product Intakes";
  var pageTitle = "Add Product Intakes";
  const location = useLocation();
  const navigate = useNavigate();
  const [localSettings, setLocalSettings] = useState({});
  const [filteredServiceItems, itemDispatch] = useReducer(
    serviceItemReducer,
    []
  );
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [uploadedInvoice, setUploadedInvoice] = useState(null);
  const [uploadedInvoiceName, setUploadedInvoiceName] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState(Utils.GetCurrentDate());
  const [isLoading, setIsLoading] = useState(false);
  const [productIntakesList, setProductIntakesList] = useState([]);
  const [productIntakeSaved, setProductIntakeSaved] = useState(false);
  const [isProductIntakeEdit, setIsProductIntakeEdit] = useState(false);
  const [productIntakeId, setProductIntakeId] = useState(null);
  const [isMsgConfirm, setIsMgsConfirm] = useState(false);
  const [openAddNewProduct, setOpenAddNewProduct] = useState(false);
  const [newProductIntake, setNewProductIntake] = useState({});
  const [Catlist, setCatlist] = useState([]);
  const [Deptlist, setDeptlist] = useState([]);
  const [itemComplimentaryList, setItemComplimentaryList] = useState([]);
  const [isOpenAddProductSelection, setIsOpenAddProductSelection] = useState(false);
  const [fetchedProducts, setFetchedProducts] = useState([]);
  const [visibleProducts, setVisibleProducts] = useState([]);
  const [overallCategoryList, setOverallCategoryList] = useState([]);
  const [overallTypeList, setOverallTypeList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [filterFetchedProducts, setFilterFetchedProducts] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [isVendorDialogOpen, setIsVendorDialogOpen] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [totalCost, setTotalCost] = useState(0);
  useEffect(() => {
    let localSetting = connectToStore();
    if (UserHelper.CheckPermission(ProductInvoicePage, navigate)) {
      setLocalSettings(localSetting);
      if (!Utils.IsNullOrEmpty(location.state) || location?.state?.isProductIntakeEdit || location?.state?.isfromVendorSetup) {
        if (location?.state?.isfromVendorSetup) {
          if (location?.state?.selectedVendor) {
            setSelectedVendor(location.state.selectedVendor);
          }
          if (location?.state?.serviceitems) {
            itemDispatch({
              type: serviceItemActionTypes.Clear,
            });
            (location?.state?.serviceitems ?? []).forEach((serviceItem) => {
              itemDispatch({
                type: serviceItemActionTypes.Add,
                value: serviceItem,
              });
            });
          }
        }
        if (location?.state?.isProductIntakeEdit) {
          hanldeEditProductIntake();
          setIsProductIntakeEdit(true);
        }
      }
    }
  }, []);

  useEffect(() => {
    getSpares();
    getVendorDetails();
  }, [localSettings]);

  const hanldeEditProductIntake = () => {
    if (!Utils.IsNullOrEmptyObject(location.state.storedProductIntake)) {
      let storedProductIntake = location.state.storedProductIntake;
      setVendorName(storedProductIntake.vendorName);
      setInvoiceNumber(storedProductIntake.invoiceNumber);
      setInvoiceDate(moment(storedProductIntake.invoiceDate));
      setUploadedInvoice(storedProductIntake.invoiceCopyUrl);
      setUploadedInvoiceName(storedProductIntake.invoiceFileName);
      setProductIntakeId(storedProductIntake.id);
      const selected = vendorList.find(
        v => v.id === storedProductIntake.vendorId
      );
      setSelectedVendor(selected || null);
      setTotalCost(storedProductIntake.totalProductPrice);
      itemDispatch({ type: serviceItemActionTypes.Clear });
      if (!Utils.IsNullOrEmptyArray(storedProductIntake.serviceItems)) {
        populateFromServiceItems(storedProductIntake.serviceItems);
      }
    }
  }
  const getServiceItemObj = (item) => {
    return convertServiceItemObject(item, true);
  };

  const populateFromServiceItems = (serviceItems) => {
    var itemComps = [...itemComplimentaryList];
    if (!Utils.IsNullOrEmptyArray(serviceItems)) {
      serviceItems.forEach((serviceitem, index) => {
        var newItem = getServiceItemObj(serviceitem);
        var comp = extractItemComplimentaryFromServiceItem(newItem);
        if (!Utils.IsNullOrEmptyObject(comp)) {
          itemComps.push(comp);
        }

        if (!Utils.IsNullOrEmpty(newItem)) {
          newItem.Sequence = index + 1;
          itemDispatch({
            type: serviceItemActionTypes.Add,
            value: newItem,
          });
        }
      });
      setItemComplimentaryList(itemComps);
    }
  };

  const extractItemComplimentaryFromServiceItem = (serviceItem) => {
    if (
      !Utils.IsNullOrEmptyArray(serviceItem.Discounts) &&
      serviceItem.Discounts.some((d) => d.Complimentary && !d.OrderLevel)
    ) {
      var discount = serviceItem.Discounts.filter(
        (d) => d.Complimentary && !d.OrderLevel
      )[0];
      if (Utils.IsNullOrEmptyObject(discount)) {
        return {};
      }
      return {
        orderLevel: false,
        productId: serviceItem.ProductId,
        index: serviceItem.Sequence,
        value: discount.DiscountValue,
        type: discount.DiscountType,
        discount: discount.DiscountTotal,
        compId: discount.CampaignId,
      };
    }
    return {};
  };

  const setAlert = (msg) => {
    setAlertMessage(msg);
    setShowAlert(true);
    if (msg === AlertMessageTxt.confirmUpdateMethod) {
      setIsMgsConfirm(true);
    }
  };

  const addItemToCart = (
    product,
    isCustomProduct = false,
    isProductIntakeEdit = false,
    sequenceValue = 0
  ) => {
    if (
      !Utils.IsNullOrEmptyObject(
        filteredServiceItems.find((s) => s.ProductId === product.id)
      )
    ) {
      setAlert(AlertMessageTxt.productAlreadyAdded);
      return;
    }
    var serviceItem = isCustomProduct
      ? product
      : isProductIntakeEdit
        ? convertServiceItemObject(product)
        : getServiceItemFromProduct(product);
    serviceItem.reviewProduct = product.reviewProduct;
    serviceItem.imageUrl = product.imageUrl;
    if (isCustomProduct) {
      serviceItem.newProduct = true;
    }
    if (
      Utils.IsNullOrEmptyArray(filteredServiceItems) &&
      !isProductIntakeEdit
    ) {
      serviceItem.Sequence = 1;
    } else {
      if (!isProductIntakeEdit) {
        serviceItem.Sequence =
          filteredServiceItems[filteredServiceItems.length - 1].Sequence + 1;
      }
    }
    if (sequenceValue) {
      serviceItem.Sequence = sequenceValue;
    }
    itemDispatch({
      type: serviceItemActionTypes.Add,
      value: serviceItem,
    });
    configureDialog();
  };

  const configureDialog = () => {
    if (!showDialog) {
      setShowDialog(true);
    }
  };

  const handleServiceItemActions = (action) => {
    if (action.type === serviceItemActionTypes.Clear) {
      setItemComplimentaryList([]);
    }
    if (action.type === serviceItemActionTypes.Delete) {
      var itemComps = [...itemComplimentaryList];
      var serviceItem = filteredServiceItems[action.value];
      if (
        !Utils.IsNullOrEmptyArray(serviceItem) &&
        !Utils.IsNullOrEmptyArray(serviceItem.Discounts)
      ) {
        itemComps = itemComps.filter((i) => i.index !== serviceItem.Sequence);
        setItemComplimentaryList(itemComps);
      }
    }
    if (
      action.type === serviceItemActionTypes.Clear ||
      (filteredServiceItems.length === 1 &&
        action.type === serviceItemActionTypes.Delete)
    ) {
      setShowDialog(false);
    }
    itemDispatch(action);
  };

  const UploadInvoiceFile = async (event) => {
    var file = event.target.files[0];
    if (file.size > MaxFileSizeLimit) {
      setAlert(AlertMessageTxt.fileSixeExceeded);
      return;
    }
    var base64 = await convertBase64(file);
    setUploadedInvoice(base64);
    setUploadedInvoiceName(file.name);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const removeInvoiceFile = () => {
    setUploadedInvoice(null);
    setUploadedInvoiceName("");
  };

  const formatFileName = (name) => {
    if (!name) return "";
    if (name.length <= 15) return name; // no need to shorten small names
    const start = name.substring(0, 6);
    const end = name.substring(name.length - 8); // last 8 characters
    return `${start}...${end}`;
  };

  const getInvoiceFileObj = (selectedUrl) => {
    return {
      url: Utils.IsNullOrEmpty(selectedUrl)
        ? ""
        : selectedUrl.startsWith("http")
          ? selectedUrl
          : Utils.GetStringFromBase64(selectedUrl),
      newFile:
        !Utils.IsNullOrEmpty(selectedUrl) && !selectedUrl.startsWith("http"),
    };
  };

  const SubmitProductIntakes = async (intakeStatus) => {
    setIsLoading(true);
    if (Utils.IsNullOrEmptyArray(filteredServiceItems)) {
      setAlert(AlertMessageTxt.addProducts);
      setIsLoading(false);
      return;
    }
    if (Utils.IsNullOrEmpty(totalCost)) {
      setAlert("please enter the price");
      setIsLoading(false);
      return;
    }
    if (Utils.IsNullOrEmpty(selectedVendor)) {
      setAlert("please select the vender Details");
      setIsLoading(false);
      return;
    }
    let isPriceDetailsFilled = checkPriceDetailsFilled();
    if (!isPriceDetailsFilled) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    const invoiceFileObj = getInvoiceFileObj(uploadedInvoice);
    let result = await addNewProductData();
    if (result[1]) {
      setIsLoading(false);
      return;
    }
    let newfilteredServiceItem = result[0];
    let obj = {
      vendorName: selectedVendor.vendorName,
      invoiceNumber: invoiceNumber,
      invoiceDate: invoiceDate,
      invoiceCopyUrl: invoiceFileObj.url,
      invoiceFileName: uploadedInvoiceName,
      serviceItems: newfilteredServiceItem,
      businessId: localSettings.business.id,
      branchId: localSettings.branch.branchId,
      status: intakeStatus,
      id: productIntakeId,
      VendorId: selectedVendor.id,
      TotalProductPrice: Math.round(Number(totalCost) * 100) / 100

    };
    let response = await postAsync("ProductIntakes/SaveProductIntakes", {
      BusinessId: localSettings.business.id,
      BranchId: localSettings.branch.branchId,
      NewProductIntake: true,
      ProductIntake: obj,
    });
    if (response.error) {
      setAlert(response.error);
    } else {
      if (!Utils.IsNullOrEmptyArray(response.data)) {
        setProductIntakesList(response.data);
        setProductIntakeSaved(true);
        if (intakeStatus === "Updated") {
          setAlert(AlertMessageTxt.productIntakeUpdated);
        } else {
          setAlert(AlertMessageTxt.productIntakeSaved);
        }
      }
    }
    setIsLoading(false);
  };

  const checkPriceDetailsFilled = () => {
    let isPriceDetailsFilled = true;
    if (!Utils.IsNullOrEmptyArray(filteredServiceItems)) {
      filteredServiceItems.forEach((item) => {
        if (Utils.IsNullOrEmpty(item?.Price)) {
          setAlert(AlertMessageTxt.FillPriceDetails);
          isPriceDetailsFilled = false;
        }

      })
    }
    return isPriceDetailsFilled;
  }

  const addNewProductData = async () => {
    const updatedItems = [];

    for (const item of filteredServiceItems) {
      item.ProductHSN = !Utils.IsNullOrEmpty(item.HSN) ? item.HSN : item.ProductHSN;
      if (item.newProduct) {
        let obj = {
          BusinessId: localSettings.business.id,
          Active: true,
          Description: item.BriefDescription,
          ShortDesc: item.Description,
          Code: item.ProductCode,
          Cost: item.Cost,
          Price: item.Price,
          TaxPercent: item.TaxPercent,
          MeasuringUnit: item.MeasuringUnit,
          Service: item.Service,
          IsMaterial: item.Material,
          Labour: item.Labour,
          InclusiveOfTax: item.InclusiveOfTax,
          PriceIncludingTax: item.PriceIncludingTax,
          Class: item.Class,
          ClassDescription: item.ClassDescription,
          Department: item.Department,
          DepartmentDescription: item.DepartmentDescription,
          Color: item.Color,
          Sku: item.Sku,
          Size: item.Size,
          HSN: item.HSN,
          BrandName: item.BrandName,
          TrackInventory: true,
        };
        let result = await postAsync(
          "Product/SaveProduct",
          {
            BusinessId: localSettings.business.id,
            NewProduct: true,
            Product: obj,
          },
          "",
          "Execute",
          "",
          []
        );
        if (result.error) {
          setAlert(result.errorMessage);
          return [updatedItems, true];
        }
        updatedItems.push({
          ...item,
          ProductId: result.data.productId,
        });
      } else {
        // keep unchanged
        updatedItems.push(item);
      }
    }
    return [updatedItems, false];
  };

  const backNavigation = () => {
    navigate(ProductIntakesPage.Path);
  };

  const handleMsgClose = (value) => {
    setShowAlert(false);
    if (productIntakeSaved) navigate(ProductIntakesPage.Path);
    if (
      alertMessage === AlertMessageTxt.confirmUpdateMethod &&
      value === "OK"
    ) {
      SubmitProductIntakes("Updated");
    }
  };

  const handleNewProduct = () => {
    setNewProductIntake({});
    setOpenAddNewProduct(true);
  };

  const handleCloseAddNewProduct = () => {
    setOpenAddNewProduct(false);
  };
  const handleAddNewProductIntake = (obj) => {
    if (!Utils.IsNullOrEmptyObject(obj)) {
      setNewProductIntake(obj);
      addItemToCart(obj, true);
    }
  };

  const getSpares = async () => {
    if (localSettings.authenticated) {
      setIsLoading(true);
      let result1 = await postAsync(
        "Product/GetProduct",
        {},
        "",
        "GetAll",
        "AllProductsAndMaterialsForBusiness",
        [localSettings.business.id]
      );
      if (result1.error) {
        setAlert(result1.errorMessage);
      } else {
        if (!Utils.IsNullOrEmptyArray(result1.data)) {
          var Spares = result1.data.filter(
            (item) =>
              item.isMaterial == false &&
              item.service == false &&
              item.labour == false
          );
          const temDeptllist = [];
          const temCatllist = [];
          Spares.forEach((element) => {
            if (
              !Utils.IsNullOrEmpty(element.department) &&
              !temDeptllist.includes(element.department)
            ) {
              temDeptllist.push(element.department);
            }
            if (
              !Utils.IsNullOrEmpty(element.class) &&
              !temCatllist.includes(element.class)
            ) {
              temCatllist.push(element.class);
            }
          });
          setDeptlist(temDeptllist);
          setCatlist(temCatllist);
        }
      }
      setIsLoading(false);
    }
  };

  const onAddComp = (comp) => {
    var tempCompList = [...itemComplimentaryList];
    tempCompList.push(comp);
    setItemComplimentaryList(tempCompList);
  };

  const onRemoveComp = (comp) => {
    var tempCompList = [...itemComplimentaryList];
    tempCompList = tempCompList.filter((t) => t.compId !== comp.compId);
    setItemComplimentaryList(tempCompList);
  };

  const handleEditItemComp = (comp, i) => {
    var comps = [...itemComplimentaryList];
    comps[i] = comp;
    setItemComplimentaryList(comps);
  };

  const OpenProductSelection = () => {
    const filteredIds = new Set(filteredServiceItems.map(x => x.ProductId));
    const filterProducts = fetchedProducts.filter(
      (p) => !filteredIds.has(p.id)
    );
    setFilterFetchedProducts(filterProducts)
    setSelectedIds(filteredServiceItems.map(item => item.ProductId))
    setIsOpenAddProductSelection(true);
    setVisibleProducts(filterProducts.slice(0, 1000));
  }
  const CloseProductSelection = () => {
    setIsOpenAddProductSelection(false);
  }
  const handleAddSelectedProducts = (selectedProductsIds) => {
    if (!Utils.IsNullOrEmptyArray(selectedProductsIds)) {
      const filteredItemIds = new Set(filteredServiceItems.map(item => item.ProductId));
      const filteredSelectProductIds = new Set(
        [...selectedProductsIds].filter(id => !filteredItemIds.has(id))
      );

      let sequenceIndex = filteredServiceItems.length;
      if (!Utils.IsNullOrEmptyArray(filteredServiceItems)) {
        sequenceIndex = filteredServiceItems[sequenceIndex - 1].Sequence
      }

      fetchedProducts.forEach((p, index) => {
        if (filteredSelectProductIds.size && filteredSelectProductIds.has(p.id)) {
          addItemToCart(p, false, false, ++sequenceIndex);
        }
      });
    }
  };

  const getVendorDetails = async () => {
    if (localSettings.authenticated) {
      setIsLoading(true);
      let result = await postAsync(
        "Vendor/GetVendorDetails",
        {},
        "",
        "GetAll",
        "GetAllVendorDetailsByBusiness",
        [localSettings.business.id]
      );
      if (result.error) {
        setAlert(result.errorMessage);
      } else {
        if (!Utils.IsNullOrEmptyArray(result.data)) {
          setVendorList(
            (result?.data || []).filter(v => v.vendorStatus === true)
          );
          var storedProductIntake = Utils.IsNullOrEmpty(location.state) ? "" : location.state.storedProductIntake
          if (!Utils.IsNullOrEmpty(storedProductIntake)) {
            const selected = result.data.find(
              v => v.id === storedProductIntake.vendorId
            );
            setSelectedVendor(selected || null);
            setTotalCost(storedProductIntake.totalProductPrice);
          }
        }
      }
      setIsLoading(false);
    }
  };
  const handleVendorCloseDialog = () => {
    setIsVendorDialogOpen(false);
  }
  const handleSelectedVendorDetails = () => {
    setIsVendorDialogOpen(true);
  }
  const NavigationAddVendor = () => {
    navigate(AddNewVendorPage.Path, {
      state: {
        isfromProductIntake: true,
        serviceItems: filteredServiceItems,
        _selectedVendor: selectedVendor
      }
    });
  }

  return (
    <Container maxWidth="false" className="bg-color p-0">
      <Grid className="container">
        <MessagePopup
          msgOpen={showAlert}
          msgText={alertMessage}
          onMsgClose={handleMsgClose}
          isConfirm={isMsgConfirm}
        />
        <Loader open={isLoading} />

        <VendorSelectionDialog
          open={isVendorDialogOpen}
          onClose={handleVendorCloseDialog}
          vendorList={vendorList}
          selectedVendor={selectedVendor}
          setSelectedVendor={setSelectedVendor}
          onSubmit={handleVendorCloseDialog}
        />

        <AddNewProduct
          open={openAddNewProduct}
          closeAddNewProduct={handleCloseAddNewProduct}
          handleAddNewProductIntake={handleAddNewProductIntake}
          Catlist={Catlist}
          Deptlist={Deptlist}
        />
        <Box>
          <Grid container m={0}>
            <SideBarMenuItems selectedTab={SideBarMenuNames.Overview} />
            <Grid
              xs={12}
              className="content-sec"
              sx={{ "padding-bottom": "100px" }}
            >
              <Grid container direction="row" className="">
                <Grid flex="1" spacing={2}>
                  <Grid container className="title-sec">
                    <Typography level="h2" component="h2" fontWeight="600">
                      <Button onClick={backNavigation} className="back-btn">
                        <NavigateBeforeIcon />
                      </Button>
                      {pageTitle}
                    </Typography>
                    <Button
                      id="new-product-btn"
                      className="btn btn-primary float-btn"
                      variant="contained"
                      onClick={handleNewProduct}
                    >
                      Add New Product
                    </Button>
                  </Grid>

                  <Grid
                    container
                    xs={12}
                    className="data-grid-box"
                    spacing={2}
                  >
                    <Grid item xs={12}>
                      <Card sx={{ p: 2 }} style={{ overflow: "inherit" }}>
                        <CartComponent
                          serviceItems={filteredServiceItems}
                          onAddItem={addItemToCart}
                          handleItemAction={handleServiceItemActions}
                          includePreview={true}
                          onChangeTotal={setTotalPrice}
                          onChangeCost={setTotalCost}
                          onAddComp={onAddComp}
                          itemComplimentaryList={itemComplimentaryList}
                          isFromProductIntakes={true}
                          onRemoveComp={onRemoveComp}
                          onEditComp={handleEditItemComp}
                          setFetchedProducts={setFetchedProducts}
                          OpenProductSelection={OpenProductSelection}
                          setOverallCategoryList={setOverallCategoryList}
                          setOverallTypeList={setOverallTypeList}
                          setTypeList={setTypeList}
                        />
                      </Card>
                    </Grid>

                    <Grid className="font-size-14" item xs={12}>
                      <Card sx={{ p: 2 }} style={{ overflow: "inherit" }}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Typography
                            level="h3"
                            component="h3"
                            className="section-title"
                            fontWeight="600"
                          >
                            Vendor Details Info
                          </Typography>

                          <Stack direction="row" alignItems="center"
                            spacing={2}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={0.5}
                              sx={{ cursor: "pointer" }}
                              onClick={NavigationAddVendor}
                            >
                              <IconButton aria-label="add vendor">
                                <AddCircleIcon
                                  sx={{
                                    color: "#588ce9",
                                    transform: "scale(1.7)",
                                  }}
                                />
                              </IconButton>


                              <Typography variant="body2">
                                New Vendor
                              </Typography>
                            </Stack>

                            {!selectedVendor && (
                              <Button
                                onClick={() => handleSelectedVendorDetails()}>
                                <Typography variant="h6" >
                                  Select Vendor
                                </Typography>
                              </Button>
                            )}
                          </Stack>

                        </Stack>

                        <Stack
                          sx={{ minWidth: 120 }}
                          spacing={2}
                          className="mt-2"
                        >

                          {selectedVendor ? (
                            <Card
                              onClick={() => handleSelectedVendorDetails()}
                              sx={{
                                border: "2px solid #1976d2",
                                backgroundColor: "#e3f2fd",
                                maxWidth: 400,
                                alignItems: "center"
                              }}
                            >
                              <CardContent>
                                <Typography variant="h6">
                                  {selectedVendor.vendorName}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                  {selectedVendor.vendorContact}
                                </Typography>
                              </CardContent>
                            </Card>
                          ) : (
                            <Alert severity="warning" sx={{ alignItems: "center" }}>
                              Please select a vendor
                            </Alert>
                          )}


                          {/* Invoice Fields */}
                          <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
                            <FormControl fullWidth>
                              <DecimalEntryField
                                label="Price"
                                variant="outlined"
                                error={!Utils.IsNullOrEmptyObject(totalCost)}
                                value={totalCost}
                                setValue={setTotalCost}
                                InputLabelProps={{ shrink: true }}
                              />
                            </FormControl>
                            <FormControl fullWidth>
                              <TextField
                                label="Invoice Number"
                                variant="outlined"
                                value={invoiceNumber}
                                onChange={(e) => setInvoiceNumber(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                              />
                            </FormControl>

                            <FormControl fullWidth>
                              <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                  label="Invoice Date"
                                  value={invoiceDate}
                                  maxDate={moment()}
                                  onChange={(newValue) => setInvoiceDate(newValue)}
                                  closeOnSelect
                                />
                              </LocalizationProvider>
                            </FormControl>
                          </Stack>
                          <Stack direction="row" alignItems="center" pb={2} pt={2} spacing={2}>
                            <Typography
                              level="h4"
                              component="h4"
                              fontWeight="bold"
                              className="font-size-14"
                            >
                              Upload Invoice Copy
                            </Typography>
                            {!uploadedInvoiceName && (
                              <label>
                                <UploadFileIcon
                                  fontSize="large"
                                  sx={{
                                    cursor: "pointer",
                                    marginLeft: "1rem",
                                    width: "30px",
                                    height: "30px",
                                  }}
                                />
                                <Input
                                  type="file"
                                  name="uploadedInvoice"
                                  className="hide"
                                  inputProps={{
                                    accept:
                                      "image/png, image/jpeg, image/ico, image/jpg, .pdf",
                                  }}
                                  onChange={(e) => UploadInvoiceFile(e)}
                                />
                              </label>
                            )}
                            {uploadedInvoiceName && (
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                mt={2}
                              >
                                <Typography
                                  sx={{ fontSize: "16px !important" }}
                                >
                                  {formatFileName(uploadedInvoiceName)}
                                </Typography>
                                <IconButton
                                  size="sm"
                                  color="danger"
                                  style={{ color: "red" }}
                                  onClick={removeInvoiceFile}
                                >
                                  <CloseIcon />
                                </IconButton>
                              </Stack>
                            )}
                          </Stack>
                        </Stack>
                      </Card>
                    </Grid>
                  </Grid>

                  <Grid flex="1" spacing={2} className="mt-2 fixed-btn">
                    <Grid className="container">
                      <Grid container xs={12}>
                        <Grid xs={1} alignSelf="center"></Grid>
                        <Grid xs={9} className=""></Grid>
                        <Grid
                          xs={12}
                          lg={0}
                          className="text-right"
                          sx={{ display: "flex", justifyContent: "end" }}
                        >
                          <Stack
                            direction="row"
                            sx={{ marginRight: 2 }}
                            spacing={2}
                          >
                            <Button
                              className="btn btn-primary align-self-start"
                              variant="contained"
                              onClick={(e) => { SubmitProductIntakes("Saved") }}
                              disabled={!selectedVendor}
                            >
                              {"Save"}
                            </Button>
                            {/* {!isProductIntakeEdit && ( */}
                            <Button
                              className="btn btn-primary align-self-start"
                              variant="contained"
                              disabled={!selectedVendor}
                              onClick={(e) => {
                                setAlert(AlertMessageTxt.confirmUpdateMethod);
                              }}
                            >
                              Update to Inventory
                            </Button>
                          </Stack>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <CustomAddProductSelection
              open={isOpenAddProductSelection}
              overAllproducts={filterFetchedProducts}
              limit={1000}
              onCloseProductSelection={CloseProductSelection}
              visibleProducts={visibleProducts}
              setVisibleProducts={setVisibleProducts}
              categoryList={overallCategoryList}
              typeList={typeList}
              setTypeList={setTypeList}
              overAllTypeList={overallTypeList}
              handleAddSelectedProducts={handleAddSelectedProducts}
              selectedIds={selectedIds}
            />
          </Grid>
        </Box>
      </Grid>
    </Container>
  );
};

export default ProductInvoice;
